<template>
  <v-card class="item" color="transparent" :to="to" tile flat>
    <img
      class="rounded-xl d-block item-img"
      :src="files + img"
      :alt="title"
      width="100%"
    />

    <div class="item-caption">
      <v-sheet
        class="
          primary--text
          d-flex
          justify-center
          align-center
          text-center text-h2
          my-6
          item-title-container
        "
        color="transparent"
        height="68px"
        width="100%"
      >
        <span class="item-title">
          {{ title }}
        </span>
      </v-sheet>

      <div v-if="price" class="text-h5 text-center item-price">
        <span class="font-secondary">
          {{ formatPrice(price) }}
        </span>
      </div>

      <div v-if="subcategory.title" class="text-center mt-8">
        <span class="py-1 px-3 primary lighten-3 rounded-pill font-secondary">
          {{ subcategory.title }}
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatPrice } from "../../utils/formatPrice";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    subcategory: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatPrice,
  },
};
</script>

<style lang="scss">
.item {
  &-img {
    aspect-ratio: 1 / 1;
    -o-object-fit: cover;
    object-fit: cover;
  }

  &-title {
    -webkit-box-orient: vertical;
    box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 35px !important;
    overflow: hidden;
  }
}
</style>
